import React, { useState, useRef, useEffect } from "react";
import '../style/common.css';
import PersonalDetails from "./personal-details";
import EmploymentStatus from "./employment-details";
import EmiDetails from "./emi-details.js";
import ExpensesDetails from "./expenses-details.js";
import { StepProgressBar } from "../component/progressbar/index.tsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UploadDocument from "./UploadDocuments.js";

function MortgageForm() {
    const navigate = useNavigate();
    const childRef = useRef();
    const { step } = useParams();
    const [currentPage, setCurrentPage] = useState(null);
    const step1Content = <PersonalDetails onNextPage={onClickNextPage}  onPriviousPage={onClickPreviosPage}/>;
    const step2Content = <EmploymentStatus onNextPage={onClickNextPage} onPriviousPage={onClickPreviosPage} />;
    const step3Content = <ExpensesDetails onNextPage={onClickNextPage} onPriviousPage={onClickPreviosPage}/>;
    const step4Content = <EmiDetails onNextPage={onClickNextPage} onPriviousPage={onClickPreviosPage}/>;
    const step5Content = <UploadDocument onNextPage={onClickNextPage} onPriviousPage={onClickPreviosPage}/>;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const applicationId = searchParams.get('applicationId');

    const formStepsArray = [
        {
            label: '',
            subtitle: '',
            name: 'step 1',
            content: step1Content
        },
        {
            label: '',
            subtitle: '',
            name: 'step 2',
            content: step2Content
        },
        {
            label: '',
            subtitle: '',
            name: 'step 3',
            content: step3Content
        },
        {
            label: '',
            subtitle: '',
            name: 'step 4',
            content: step4Content
        },
        {
            label: '',
            subtitle: '',
            name: 'step 5',
            content: step5Content
        }
    ];

    useEffect(() => {
        const stepIndex = Number(step);
        if (stepIndex >= 0 && stepIndex < formStepsArray.length) {
            if (stepIndex === 0) {
                setCurrentPage(stepIndex)
            } else if (stepIndex === 1) {
                setCurrentPage(stepIndex)
            } else if (stepIndex === 2) {
                setCurrentPage(stepIndex)
            } else if (stepIndex === 3) {
                setCurrentPage(stepIndex)
            } else if (stepIndex === 4) {
                setCurrentPage(stepIndex)
            } else {
                setCurrentPage(0)
                window.history.replaceState(null, '', `/mortgage_form/${0}?applicationId=${applicationId}`);
            }
        } else {
            navigate(`/mortgage_form/${0}?applicationId=${applicationId}`);
        }
    }, [step, navigate, formStepsArray.length]);

    function onclickStep(index) {
        if (index < formStepsArray.length) {
            setCurrentPage(index);
            navigate(`/mortgage_form/${index}?applicationId=${applicationId}`);
            window.scrollTo(0, 0);
        }
    }

    // Use function declaration (hoisted)
    function onClickNextPage() {
        childRef.current.onClickNext();
        const nextPage = currentPage + 1;
        if (nextPage < formStepsArray.length) {
            localStorage.setItem('currentPage', nextPage);
            setCurrentPage(nextPage);
            navigate(`/mortgage_form/${nextPage}?applicationId=${applicationId}`);
            window.scrollTo(0, 0);
        }
    }


    function onClickPreviosPage() {
        childRef.current.onClickPrevious();
        const nextPage = currentPage - 1;
        setCurrentPage(null);
        if (nextPage < formStepsArray.length) {
            
            setCurrentPage(nextPage);
            navigate(`/mortgage_form/${nextPage}?applicationId=${applicationId}`);
            window.scrollTo(0, 0);
        }
    }

    return (
        currentPage == null ? <></> :
            <>
                <div className="main_container">
                    <StepProgressBar
                        ref={childRef}
                        startingStep={currentPage}
                        steps={formStepsArray}
                        onStepClicked={onclickStep}
                    />
                </div>
            </>
    );
}

export default MortgageForm;